export default {
  giftcards: [
    /* {
      id: 1,
      name: "Giftcard 1",
      sellingPrice: "100",
      giftcardAmnt: "100",
      image: ""
    },
    {
        id: 1,
        name: "Giftcard 2",
        sellingPrice: "100",
        giftcardAmnt: "100",
        image: ""
      },
      {
        id: 1,
        name: "Giftcard 3",
        sellingPrice: "100",
        giftcardAmnt: "100",
        image: ""
      },
      {
        id: 1,
        name: "Giftcard 4",
        sellingPrice: "100",
        giftcardAmnt: "100",
        image: ""
      },
      {
        id: 1,
        name: "Giftcard 5",
        sellingPrice: "100",
        giftcardAmnt: "100",
        image: ""
      },
      {
        id: 1,
        name: "Giftcard 6",
        sellingPrice: "100",
        giftcardAmnt: "100",
        image: ""
      },
      {
        id: 1,
        name: "Giftcard 7",
        sellingPrice: "100",
        giftcardAmnt: "100",
        image: ""
      } */
  ],
  merchant: {
    companyName: "",
    mcSalesManUid: "",
    companyROCNo:"",
    brandName: "",
    brandDesc: "",
    ownerName: "",
    ownerContactNo: "",
    picName: "",
    picContactNo: "",
    picEmail: "",
    ownerEmail: "",
    picDesignation: "",
    address1: "",
    address2: "",
    address3: "",
    address4: "",
    postcode: "",
    state: "",
    bankName: "",
    accountName: "",
    accountNo: "",
    packages: []
  }
};
